<template>
  <div class="minimum-redeem-detail">
    <div class="minimum-redeem-detail__header">
      <Heading class="minimum-redeem-detail__text" :level="3">
        Por produto
      </Heading>
      <BaseText
        class="minimum-redeem-detail__text"
        :color="NebraskaColors.textSecondary"
        size="sm"
      >
        {{ detailProps.minimumRedemption.subTitle }}
      </BaseText>
    </div>
    <div class="minimum-redeem-detail__wrapper">
      <Row
        v-for="(item, index) in detailProps.allocations.portfolioSummary"
        :key="index"
        has-line
      >
        <template #top-left>
          <BaseText :color="NebraskaColors.textSecondary" size="lg">
            {{ item.name }}
          </BaseText>
        </template>
        <template #top-right>
          <BaseText :color="NebraskaColors.textPrimary" size="lg">
            {{ getRowValues(item.minimumDeposit) }}
          </BaseText>
        </template>
      </Row>
      <Row has-line>
        <template #top-left>
          <BaseText
            class="minimum-redeem-detail__bold"
            :color="NebraskaColors.textPrimary"
            size="lg"
          >
            {{ detailProps.minimumRedemption.title }}
          </BaseText>
        </template>
        <template #top-right>
          <BaseText
            class="minimum-redeem-detail__bold"
            :color="NebraskaColors.textPrimary"
            size="lg"
          >
            {{ getRowValues(detailProps.allocations.productsMinimumDeposit) }}
          </BaseText>
        </template>
      </Row>
    </div>
    <div class="minimum-redeem-detail__wrapper">
      <Heading :level="3" class="minimum-redeem-detail__text">
        Como é calculado?
      </Heading>
      <template
        v-for="(item, index) in detailProps.minimumRedemption.description"
      >
        <BaseText
          :key="index"
          :color="NebraskaColors.textSecondary"
          as="p"
          size="md"
          class="minimum-redeem-detail__content"
        >
          {{ item }}
        </BaseText>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Row, Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IAppliedAllocations } from '@/modules/wealth/services/investment/investment-types';
import { moneyFormat } from '@/modules/common/helpers/currency';
import { IPortfolioSummaryDetailsProps } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';

@Component({
  components: {
    Heading,
    Row,
    BaseText
  }
})
export default class MinimumRedeemDetail extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @Prop({ type: Object, required: true })
  readonly detailProps!: {
    allocations: IAppliedAllocations;
    minimumRedemption: IPortfolioSummaryDetailsProps;
  };

  public getRowValues(value: number) {
    return moneyFormat(value, false);
  }
}
</script>

<style lang="less" scoped>
.minimum-redeem-detail {
  width: 100%;

  &__text {
    margin-bottom: 0;
    text-align: start;
  }

  &__wrapper {
    margin-bottom: @size-spacing-x600;
  }

  &__header {
    margin-bottom: @size-spacing-x400;
  }

  &__faq-link {
    text-decoration: none;
    font-weight: bold;
  }

  &__bold {
    font-weight: bold;
  }

  &__content {
    margin: @size-spacing-x350 0;
    text-align: start;
  }
}
</style>
